export default __webpack_public_path__ + "static/media/rounded-rectangle-1-break.8b1d0e53.webp";